module.exports = __webpack_public_path__ + "static/media/Image-Footer.3e10184e.png";